import { Injectable } from '@angular/core';

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

@Injectable({
  providedIn: 'root',
})
export class CsvDataService {

  exportToCsv(filename: string, rows: object[]) {
    if (!rows || !rows.length) {
      return;
    }

    // Costruisci l'intestazione del CSV con le chiavi
    const keys = Object.keys(rows[0]);
    let csvContent = keys.map(key => `"${key}"`).join(',') + '\n';

    // Aggiungi i valori delle righe sotto le colonne corrispondenti
    rows.forEach((row: any) => {
      csvContent += keys.map(key => {
        const value = row[key] !== undefined && row[key] !== null ? row[key] : '';
        return `"${value}"`; // Aggiungi il valore racchiuso tra virgolette
      }).join(',') + '\n';
    });

    // Crea e scarica il file CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

}